import { addDoc, collection, serverTimestamp } from 'firebase/firestore';
import { db } from '../firebase';
import type { ScreenLockOutcome } from '../types/feedTools';

class FeedToolAnalyticsService {
  async logScreenLockEvent(params: {
    userId: string;
    outcome: ScreenLockOutcome;
    device: 'desktop' | 'mobile';
    relevanceScore: number;
    xItemsAtTrigger: number;
  }): Promise<void> {
    try {
      await addDoc(collection(db, 'feedToolAnalytics'), {
        type: 'screen_lock',
        ...params,
        createdAt: serverTimestamp(),
      });
    } catch (error) {
      console.warn('Failed to log screen lock event:', error);
    }
  }
}

export const feedToolAnalyticsService = new FeedToolAnalyticsService();
